import React from 'react'
import { Spinner, Box, Button } from 'grommet'

const LoadEarlier = ({
  onLoadEarlier = () => {},
  isLoadingEarlier = false,
  label = 'Load earlier messages'
}) => {
  if (isLoadingEarlier === false) {
    return (
      <Box style={{ minHeight: '50px' }}>
        <Button
          alignSelf="center"
          margin="small"
          onClick={onLoadEarlier}
          label={label}
        />
      </Box>
    )
  }
  return (
    <Box style={{ minHeight: '50px' }}>
      <Button label={label} />
      <Spinner color="white" size="small" />
    </Box>
  )
}

export default LoadEarlier
